<template>
  <div class="flex flex-col">
    <h5 class="font-bold text-gray-700">Logged in user: {{ user.Username }} ({{ user.RolesLabel.join(', ') }})</h5>
    <h5 class="font-bold text-gray-700">
      {{ timestamp }} (Malaysia Time)
    </h5>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      timestamp: ''
    }
  },
  mounted() {
    // set locale to malaysian
    // moment.locale('ms-my')
    // console.log('inimang this.$store', this.$store)
    setInterval(_ => {
      this.timestamp = moment().format('DD/MM/YYYY hh:mm')
    }, 3000)
  },
  computed: {
    user() {
      return this.$store.getters.userData
    }
  }
}
</script>
